import { render, staticRenderFns } from "./Collapsable.vue?vue&type=template&id=2ebbab81&scoped=true"
import script from "./Collapsable.vue?vue&type=script&lang=js"
export * from "./Collapsable.vue?vue&type=script&lang=js"
import style0 from "./Collapsable.vue?vue&type=style&index=0&id=2ebbab81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebbab81",
  null
  
)

export default component.exports